import Container from '@mui/material/Container';
import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import DrawerAppBar from '../components/nav';
import {Typography }from '@mui/material';

const HomeWrapper = styled(Container)`
    height:100vh;
    display: flex;
    align-items: center;
    background-image:url("./assets/Home BG.png");
    background-color:#1A86E1;
    background-size:cover;
    background-position:center;
    background-repeat:no-repeat;
    padding: 0px 24px;
`
const HomeContentWrapper = styled(Grid)`
    background:#000;
    border-radius:20px;
    padding:35px 40px 30px 30px;
    margin-top:20px;
    @media (max-width: 1400px) and (min-width: 375px){
            padding:25px 30px 20px 20px;
        }
    @media (max-width: 600px){
        padding:20px;
    }
    @media (min-width: 2000px){
            padding:50px 80px 50px 50px;
        }
`
const HomeHeading = styled(Typography)`
    color:#F3D332;
    font-size:60px;
    font-weight:bold;
    text-transform:uppercase;
    @media (max-width: 767px) and (min-width: 375px){
                font-size:40px;
            }
    @media (max-width: 1024px) and (min-width: 768px){
            font-size:45px;
        }
    @media (max-width: 1400px) and (min-width: 1024px){
                font-size:60px;
            }
    @media (max-width: 1999px) and (min-width: 1399px){
            font-size:80px;
            }
    @media (max-width: 2149px) and (min-width: 2000px){
                font-size:100px;
            }
    @media (max-width: 2500px) and (min-width: 2150px){
                font-size:120px;
            }
    @media (min-width: 2501px){
            font-size:145px;
            }
    @media (max-width: 374px){
                font-size:35px;
            }
`
const HomeDescription = styled(Typography)`
    color:#fff;
    font-size:14px;
    font-weight:400;
    @media (min-width:2000px){
                font-size:30px;
            }
`
const BtnWrapper = styled.div`
    display:Flex;
    margin:15px 0px !important;
`
const BuyBtn = styled.a`
    color:#000;
    background:#F3D332;
    font-size:18px;
    font-weight:400;
    border-radius:10px;
    text-align:center;
    width: 170px;
    padding: 10px;
    margin-right:10px;
    @media (max-width: 749px){
            font-size:16px;
        }
    @media (min-width: 2000px){
            font-size:40px;
            width: 240px;
        }
`
const ChartBtn = styled.a`
    color:#fff;
    background:#6C2223;
    font-size:18px;
    font-weight:400;
    border-radius:10px;
    text-align:center;
    width: 170px;
    padding: 10px;
    margin-right:10px;
    @media (max-width: 749px){
            font-size:16px;
        }
    @media (min-width: 2000px){
        font-size:40px;
        width: 240px;
        }
`
const SocialWrapper = styled.div`
    display:flex;
    align-items: center;
    margin-top:10px;
    @media (min-width: 2000px){
        margin-top:30px;
        }
`
const SocialText = styled(Typography)`
    color:#fff;
    font-size:20px;
    font-weight:500;
    @media (min-width: 2000px){
            font-size:40px;
        }
`
const SocialLink = styled.a`
    background:#F3D332;
    border-radius:36px;
    padding: 10px;
    margin: 0px 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    @media (min-width: 2000px){
    padding: 12px;
    border-radius: 137px;
    height: 60px;
    width: 60px;
    }
`
const SocialImg = styled.img`
    width:22px;
    max-width:22px;
    height:auto;
    @media (min-width: 2000px){
        width:50px;
        max-width:50px;
        height:auto;
    }
`
export default function Welcome() {

  return (
        <>
        <DrawerAppBar />
        <HomeWrapper maxWidth="xxl">
            <Grid container >
                <HomeContentWrapper item xs={12} sm={6.5} md={6} lg={5} xl={5} xxl={5}>
                <HomeHeading variant="h1" >
                    Welcome to<br/>
                    BabY PSYOP
                </HomeHeading>
                <HomeDescription variant='p'>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, 
                    sed diam nonumy eirmod tempor invidunt ut labore et dolore magna
                    aliquyam erat, sed diam voluptua.
                </HomeDescription>
                <BtnWrapper>
                    <BuyBtn>Buy Now</BuyBtn>
                    <ChartBtn>View Chart</ChartBtn>
                </BtnWrapper>
                <SocialWrapper>
                    <SocialText variant='h4'>Follow Us:</SocialText>
                    <SocialLink href="#">
                        <SocialImg src="./assets/Path 2345.png" alt="" />
                    </SocialLink>
                    <SocialLink href="#">
                        <SocialImg src="./assets/Twitter.png" alt="" />
                    </SocialLink>
                </SocialWrapper>
                </HomeContentWrapper>
            </Grid>
        </HomeWrapper>
        </>
  );
}